import { useMyHardware } from "@/common/hooks/use-my-hardware.hook";

export interface ReplacedDevice {
  assetId: string;
  category: string;
  modelName: string;
}

export type ReplacedDeviceStatus = "ready" | "loading" | "not-found" | "error";

export interface PassedDeviceContext {
  category: string;
  modelName: string;
}

export interface ReplacedDeviceResult {
  device?: ReplacedDevice;
  status: ReplacedDeviceStatus;
  refetch: () => void;
}

export const useReplacedDevice = (
  assetId: string,
  passedContext?: PassedDeviceContext
): ReplacedDeviceResult => {
  const hasPassedContext = Boolean(passedContext?.category && passedContext?.modelName);
  const { data, isLoading, isError, refetch } = useMyHardware({ enabled: !hasPassedContext });

  if (hasPassedContext && passedContext) {
    return {
      status: "ready",
      device: { assetId, category: passedContext.category, modelName: passedContext.modelName },
      refetch,
    };
  }

  if (isLoading) return { status: "loading", refetch };
  if (isError) return { status: "error", refetch };

  const found = data?.devices.find(
    (candidate) => candidate.assetId === assetId || candidate.assetTag === assetId
  );
  if (!found) return { status: "not-found", refetch };

  return {
    status: "ready",
    device: { assetId: found.assetId, category: found.category, modelName: found.modelName },
    refetch,
  };
};
